module.exports = __webpack_public_path__ + "static/media/sully.3ac5c04c.jpg";